const ths = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortable: true,
    sortableId: 'id'
  },
  {
    id: 2,
    label: 'First Name',
    intlKey: 'table.first_name',
    sortable: true,
    sortableId: 'participantPerson.firstName'
  },
  {
    id: 3,
    label: 'Last Name',
    intlKey: 'table.last_name',
    sortable: true,
    sortableId: 'participantPerson.lastName'
  },
  {
    id: 5,
    label: 'Finished',
    intlKey: 'table.finished',
    sortable: false
  },
  {
    id: 7,
    label: 'Evidence',
    intlKey: 'table.evidence',
    sortable: false
  },
  {
    id: 8,
    label: 'Assessor Approval',
    intlKey: 'table.assessor_approval',
    sortable: false
  },
  {
    id: 9,
    label: 'Note for AL',
    intlKey: 'table.note_for_al',
    sortable: false
  },
  {
    id: 10,
    label: 'Action',
    intlKey: 'table.action',
    sortable: false
  }
]

export default ths
